//IMPORTING COLORS
import {
  WHITE,
  TEXT_COLOR,
  PRIMARY_BTN_GK,
  TITLE_COLOR_GK,
  FADE_BG_GK,
  FOOTER_BG_GK,
} from "../../utils/colors";

//IMPORTING FONT
import { TITLE_SIZE, SUB_TITLE_SIZE, TEXT_SIZE } from "../../utils/fonts";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { useState, useEffect } from "react";
import BannerSection from "../../components/BannerSection";
import FooterBar from "../../components/FooterBar";
import CandleModal from "../../components/CandleModal";
import { TbCandle } from "react-icons/tb";
import Candles from "../../assets/images/velas-bg.webp";
import AllCandles from "../../components/AllCandles";
import "./VelasVirtuais.css";

export default function VelasVirtuais() {
  const [modalShow, setModalShow] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="VelasVirtuais">
      <BannerSection
        white={WHITE}
        fadeBG={FADE_BG_GK}
        iconTitle={
          <TbCandle style={{ color: WHITE }} className="banner-section-icon" />
        }
        bannerTitle={"VELAS VIRTUAIS"}
        bannerTitleSize={TITLE_SIZE}
        bannerSubTitle={
          "Em memória daqueles que permanecem vivos em nossos corações."
        }
        bannerSubTitleSize={SUB_TITLE_SIZE}
        bannerBG={Candles}
        bannerBGmobile={Candles}
      />
      <Container>
        <Row md="12" className="velas-virtuais-row">
          <Col lg="7">
            <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              Acenda uma vela virtual para aquela pessoa querida que partiu, mas
              ainda vive eternamente na memória. As velas ficam disponíveis por
              7 dias nesse ambiente.
            </p>
          </Col>
          <Col lg="5" className="velas-virtuais-col">
            <Button
              className="primary-btn-velas"
              style={{
                backgroundColor: PRIMARY_BTN_GK,
                fontFamily: "Monotype-Corsiva-Regular",
                fontColor: WHITE,
                fontSize: "20px",
                width: "200px",
                borderColor: PRIMARY_BTN_GK,
              }}
              onClick={() => setModalShow(true)}
            >
              Acenda uma vela
            </Button>
            <CandleModal
              show={modalShow}
              onHide={() => setModalShow(false)}
              centered
              size="lg"
              falecido=""
              btncolor={PRIMARY_BTN_GK}
            />
          </Col>
        </Row>
      </Container>
      <AllCandles
        white={WHITE}
        titleColor={TITLE_COLOR_GK}
        textColor={TEXT_COLOR}
      />
      <FooterBar titleColor={TITLE_COLOR_GK} footerBarBG={FOOTER_BG_GK} />
    </div>
  );
}
